import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onEditAttributeRes } from "./helper";

export const editAttribute = async (params: {
  id: number;
  data: AttributeReqT;
}) => axios.put(Routes.EDIT_ATTRIBUTE + "/" + params.id, { ...params.data });

export const useEditAttribute = () =>
  useMutation({
    mutationKey: [Keys.EDIT_ATTRIBUTE_MUT],
    mutationFn: editAttribute,
    onSuccess: onEditAttributeRes,
  });
